import React from 'react';
import HeaderLogo from 'components/common/headerLogo';
import MetaTag from 'components/meta';
import useIncompleteTempoRedirect from 'hooks/useIncompleteTempoRedirect';

const title = 'You are done!';

function ConsentFormComplete() {
  useIncompleteTempoRedirect(true);

  return (
    <div className="app-page-container">
      <MetaTag title={title} />
      <div className="py-2">
        <HeaderLogo />
        <div
          className="h-[80vh] flex flex-col justify-center items-center"
        >
          <p className="text-4xl font-semibold">
            Congratulations!
          </p>
          <p className="text-base my-4">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ConsentFormComplete;
